import { css } from 'linaria';
import { strictBreakpoints } from '../../../../media';

export const QuestionsAccordionItemStyles = css`
	display: flex;
	flex-direction: column;
	padding: 32px 24px;
	border-bottom: 1px solid #e8e9eb;
	${strictBreakpoints.onlyMobile} {
		padding: 16px;
	}
`;
export const AccordionHeaderStyles = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 0;

	&.open {
		margin-bottom: 8px;
	}
`;
export const AccordionContentStyles = css`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-height: 0;
	overflow: hidden;
`;
export const AccordionOpen = css`
	max-height: 700px;
`;
export const OpenChevron = css`
	transform: scaleY(-1);
`;
export const AccordionChevron = css`
	align-self: flex-start;
	margin-left: 8px;
	cursor: pointer;
	transition: 0.3s ease-in-out;
`;
